import { Injectable, signal } from "@angular/core";

/** Matches Tailwind's `md` breakpoint used across business-fe for responsive layout. */
const MOBILE_BREAKPOINT_PX = 768;

@Injectable({ providedIn: "root" })
export class ViewportService {
  private readonly _isMobile = signal(window.innerWidth < MOBILE_BREAKPOINT_PX);
  readonly isMobile = this._isMobile.asReadonly();

  constructor() {
    window.addEventListener("resize", () => this._isMobile.set(window.innerWidth < MOBILE_BREAKPOINT_PX));
  }
}
